import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  slot: "label"
};
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tooltip = _resolveComponent("el-tooltip");
  var _component_el_form_item = _resolveComponent("el-form-item");
  return _openBlock(), _createBlock(_component_el_form_item, {
    "class": _normalizeClass($props.field.wrapper_class)
  }, {
    "default": _withCtx(function () {
      return [$props.field.label ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createTextVNode(_toDisplayString($props.field.label) + " ", 1 /* TEXT */), $props.field.help ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        "popper-class": "sidebar-popper",
        effect: "dark",
        placement: "top"
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("span", {
            innerHTML: $props.field.help
          }, null, 8 /* PROPS */, _hoisted_2)];
        }),
        "default": _withCtx(function () {
          return [_cache[0] || (_cache[0] = _createElementVNode("i", {
            "class": "tooltip-icon el-icon-info"
          }, null, -1 /* HOISTED */))];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _renderSlot(_ctx.$slots, "default"), $props.field.inline_help ? (_openBlock(), _createElementBlock("p", {
        key: 1,
        "class": "fc_inline_help",
        innerHTML: $props.field.inline_help
      }, null, 8 /* PROPS */, _hoisted_3)) : _createCommentVNode("v-if", true)];
    }),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class"]);
}